import { CareersPage } from './CareersPage';
export default CareersPage;
